import React from 'react';
import { IOrder } from '@/interfaces/order';
import TemplateFooter from './components/template-footer';
import TemplateHeader from './components/template-header';
import TemplateOrderInfo from './components/template-order-info';
import TemplateOrderInfoSecond from './components/template-order-info-second';
import TemplateOrderInfoItem from './components/template-order-info-item';

interface IProps {
  data: IOrder;
}

const TM03 = ({ data }: IProps) => {
  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        pageBreakBefore: 'always',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
      }}
    >
      <TemplateHeader
        description="สำเนา"
        titleEn="Delivery Order"
        titleTh="ใบส่งสินค้า"
        businessUnitLogo={data.businessUnitLogo}
      />
      <TemplateOrderInfo data={data} code={data.ivNo} />
      <TemplateOrderInfoSecond data={data} />
      <TemplateOrderInfoItem
        data={data}
        isShowShiptoRemark
        items={data.orderItems}
        isProductQrcode={true}
      />
      <TemplateFooter
        paidInfoTemplate="TM03"
        footerTextLeft="สำเนา - COPY"
        footerTextRight="สำเนา - สำหรับลูกค้า"
        referenceNo1={data?.customer?.reference1 || ''}
        referenceNo2={data?.customer?.reference2 || ''}
        amount={data?.summary}
        customerCode={data?.customer?.code || ''}
        ivNo={data?.ivNo}
        docNo={data?.code}
      />
    </div>
  );
};

export default TM03;
